/* eslint-disable no-nested-ternary */
import FileIcon from 'Components/common/assets/svgIcons/FileIcon';
import { AllUploadDocument } from 'Types/DocumentHubTypes';
import {
  // FILE_UPLOAD_SUCCESS,
  translateSkipAreas,
} from 'Utils/Constants';
import { getFileSize } from 'Utils/UtilityFunctions';
import {
  driver,
  maxMobile,
  maxWidth,
  primaryColor,
  primaryFont, primaryHeadingColor, retina, smMobile, wMBold, wMedium,
} from 'Utils/utilsStyle';
import { Progress } from 'antd';
import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
&.document-info-status-custom {
  .inner-div {
    border-radius: 8px;
    border: 1px solid #DADADA;
    background: #FFF;
    padding: 7px 14px;
    height: 48px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .file-info-svg-div {
      width: fit-content;
    }
    &.successfullyUploaded {
      background: #DEF6E6;
      border: 1px solid ${primaryColor};
      &.finalResult {
        background: #fff;
        border: 0px;
        padding: 7px 0px;
      }
    }
    &.inUploadProgress {
      position: relative;
      &:after {
        display: inline;
        position: absolute;
        inset: 0;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(0, rgba(222, 246, 230, 0)),
          color-stop(20%, rgba(222, 246, 230, 0.2)),
          color-stop(60%, rgba(222, 246, 230, 0.5)),
          to(rgba(222, 246, 230, 0))
        );
        background-color: linear-gradient(
          90deg,
          rgba(222, 246, 230, 0) 0,
          rgba(222, 246, 230, 0.2) 20%,
          rgba(222, 246, 230, 0.5) 60%,
          rgba(222, 246, 230, 0)
        );
        -webkit-animation: shimmer 2s infinite;
        animation: shimmer 2s infinite;
        content: "";
        width: 100vw;
      }
      .file-info-svg-div {
        z-index: 1;
      }
    }
    .upload-percentage {
      &.isSuccessful {
        color: ${primaryColor};
      }
      &.isFailed {
        color: ${driver};
      }
      color: ${primaryHeadingColor};
      font-family: ${primaryFont};
      font-size: 12px;
      font-weight: ${wMedium};
      line-height: 16px;
      letter-spacing: -0.417px;
      z-index: 1;
      white-space: nowrap;
    }
  }
}
  &.withoutStatus {
    width: 100%;
    margin-bottom: 0px;
    .file-info-svg-div { 
      width: calc(100% - 60px);
    }
    .textual-area {
      width: calc(100% - 0px) !important;
    }
  }

  &.uploadLinkCmp {
    .file-info-svg-div { 
      width: calc(100% - 0px);
      .textual-area {
        width: calc(100% - 0px);
        .file-title {
          width: 100%;
        }
      }
    }
  }

  &.showStatusWidth {
    .file-info-svg-div { 
      .file-icon-svg { 
        .textual-area { 
          width: calc(100% - 65px) !important;
        }
      }
    }
  }

  display: flex;
  align-items: center;
  justify-content: space-between;
  @media all and (max-width: ${maxMobile}) {
    flex-direction: column;
    align-items: flex-start;
  }
  .file-info-svg-div {
    display: flex;
    align-items: center;
    width: calc(100% - 200px);
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: calc(100% - 140px);
    }
    @media all and (max-width: ${maxMobile}) {
     width: 100%;
    }
    .file-icon-svg {
      width: 24px;
      height: 26px;
      flex-shrink: 0;
      margin-right: 8px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        width: 18px;
        height: 22px;
      }
    }
    .textual-area {
      display: flex;
      flex-direction: column;
      width: calc(100% - 0px) !important;
      position: relative;
      .file-title {
        font-family: ${primaryFont};
        font-weight: ${wMBold};
        font-size: 16px;
        line-height: 18px;
        letter-spacing: -0.4px;
        color: ${primaryHeadingColor};
        margin-bottom: 0px;
        width: 100%;
        @media all and (max-width: ${maxWidth}), ${retina} {
          font-size: 14px;
          line-height: 15px;
        }
        @media all and (max-width: ${maxMobile}) {
          width: calc(100% - 10px);
        }
        @media all and (max-width: ${smMobile}) {
          width: calc(100% - 70px);
        }
        &.size {
          font-size: 12px;
          font-weight: ${wMedium};
          line-height: 14px;
          color: #A0A0A0;
          @media all and (max-width: ${maxWidth}), ${retina} {
            font-size: 10px;
          }
        }
      }
    }
  }
  .upload-size {
    font-family: ${primaryFont};
    font-size: 12px;
    line-height: 15px;
    font-weight: ${wMedium};
    letter-spacing: -0.417px;
    color: ${primaryColor};
    margin-bottom: 0px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 10px;
    }
    @media all and (max-width: ${maxMobile}) {
      margin-left: 26px;
      margin-top: 2px;
    }
    &.failed {
      color:#DD0000;
    }
  }
.ant-progress {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 0;
  width: 100%;
  .ant-progress-outer {
    .ant-progress-inner {
      border-radius: 8px !important;
      border: 0;
      .ant-progress-bg {
        height: 46px !important;
        border-radius: 8px !important;
        @media all and (max-width: ${maxWidth}), ${retina} {
          height: 46px !important;
        }
      }
    }
  }
}
`;

type Props = {
  showStatus: boolean,
  uploadDocument?: AllUploadDocument,

  linkFlag?: boolean,
  uploadDocumentCount?: number
  inUploadProgress: boolean,
  successfullyUploaded: boolean,
  finalResult: boolean,
} & typeof defaultProps;

const defaultProps = {
  linkFlag: false,
  uploadDocument: {},
  uploadDocumentCount: 0,
};
const DocumentInfoStatusCustom = function DocumentInfoStatusCustom(props: Props) {
  const {
    showStatus, uploadDocument, linkFlag, uploadDocumentCount,
    inUploadProgress, successfullyUploaded, finalResult,
  } = props;

  const {
    file, status,
    failReason
  } = uploadDocument;
  const isSuccessful = status === 'success';
  const inProgress = status === 'inProgress';
  const isFailed = status === 'failed';
  const isPending = status === 'pending';

  return (
    <Wrapper className={classNames('document-info-status-custom', {
      showStatusWidth: showStatus,
      withoutStatus: !showStatus,
      uploadLinkCmp: linkFlag && !showStatus,
      uploadComplete: finalResult,
    })}
    >
      <div className={classNames('inner-div', {
        inUploadProgress,
        successfullyUploaded,
        finalResult,
      })}
      >
        <div className="file-info-svg-div">
          <FileIcon />
          <div className={`textual-area ${translateSkipAreas}`}>
            <h4 className="file-title text-truncate-one-line">{file?.name}</h4>
            {file?.size ? (
              <span className="file-title size">
                File size:
                {' '}
                {getFileSize(file?.size)}
              </span>
            ) : null}
          </div>
        </div>
        {inProgress || isPending ? (
          <span className="upload-percentage">
            {isPending ? 0 : uploadDocumentCount}
            %
          </span>
        ) : null}
        {isSuccessful ? (
          <span className="upload-percentage isSuccessful">
            Uploaded Successfully
          </span>
        ) : null}
        {isFailed ? (
          <span className="upload-percentage isFailed">
            {failReason ?? 'Cancelled Upload'}
          </span>
        ) : null}
        {!successfullyUploaded ? <Progress percent={isPending ? 0 : (isSuccessful || isFailed) ? 100 : uploadDocumentCount} showInfo={false} strokeColor="#DEF6E6" trailColor="#fff" /> : null}
      </div>
    </Wrapper>
  );
};
DocumentInfoStatusCustom.defaultProps = defaultProps;
export default DocumentInfoStatusCustom;
